module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_bg.9e051622.png";